import { Component, h } from 'preact';
import linkState from 'linkstate';

import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { OFFER_SENT_STATUSES } from '../../../../../constants/inquiries';
import { InquiryDocument } from '../../../../../types/inquiries/inquiry-document.model';
import { Inquiry } from '../../../../../types/inquiries';
import { ReqState } from '../../../../../types';
import { inquiryService } from '../../../../utils/inquiry.service';

interface InqOfferStatusModalProps {
  onClose: () => void;
  inquiry: Inquiry;
  document: InquiryDocument;
}

interface InqOfferStatusModalState {
  status?: string;
  reqState?: ReqState
}

export class InqOfferStatusModal extends Component<InqOfferStatusModalProps, InqOfferStatusModalState> {
  constructor(props) {
    super(props);

    this.state = {
      status: props.document.status
    };
  }

  onUploadButtonClick() {
    const { inquiry, document } = this.props;
    const newStatus = this.state.status;
    try {
      this.setState({ reqState: ReqState.IN_PROGRESS });
      inquiryService.updateSentOfferStatus(inquiry.inquiryCode, document.loiKey, newStatus);
      this.setState({ reqState: ReqState.SUCCESS });

      this.props.onClose();
    } catch (err) {
      this.setState({ reqState: ReqState.FAILED });
    }
  }

  getUploadButton() {
    if (this.state.reqState == ReqState.IN_PROGRESS) {
      return (
        <button className="btn btn-secondary hi-inqloistat__upload-button" disabled>
          <i className="fas fa-cog fa-spin" /> Working...
        </button>
      );
    } else {
      return (
        <button className="btn btn-secondary hi-inqloistat__upload-button"
          onClick={ () => this.onUploadButtonClick() }>
          Upload
        </button>
      ); 
    }
  }

  render(props: InqOfferStatusModalProps, state: InqOfferStatusModalState) {
    return (
      <HopplerModalizer onClose={ () => null }>
        <div className="hi-inqloistat">
          <div className="hi-inqloistat__title-bar">
            <span className="hi-inqloistat__title-label">
              Update Status
            </span>
            <button className="btn btn-link hi-inqloistat__title-close" onClick={ this.props.onClose }>
              <i className="fas fa-times" /> Close
            </button>
          </div>

          <div className="hi-inqloistat__content">
            <div className="hi-input-group">
              <label className="hi-input-group__label">Status</label>
              <select className="form-control" onChange={ linkState(this, 'status') }
                value={ state.status }
                disabled={ state.reqState == ReqState.IN_PROGRESS }>
                { OFFER_SENT_STATUSES.map(offerStatus => (
                  <option value={ offerStatus }>{ offerStatus }</option>
                )) }
              </select>
              {/* <span className="hi-type-caption">
                <strong>Note: </strong>
                Uploader will be automatically notified via their own Kumita.
              </span> */}
            </div>

            { this.getUploadButton() }
          </div>
        </div>
      </HopplerModalizer>
    );
  }
}
